module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAACE3AAAhNwEzWJ96AAABBklEQVRoge2ZsQ2DMBRELxnEomCAMAIjsEFSMkamoEw2IKNkAArEBGyQCMl02InNt76j3Gstn+9hAcUHIfs4SD+/oTU3AGfH8r3spovkeaICH8qviEqICXxZfkVMwikwtOYEoAdQSBy0gxFAU3bTcyvi6MnNoTxsh9616BPIofxKMbRms49PICvKbhpDBTY3KOHs4hNoMpEYbRdCUhD8Jx5a80p5E2U3BXX6mc+oCwpoQwFtKKANBbShgDYU0IYC2lBAGwpoQwFtKKDNXwrMCXpEZ8cIPCL2JMuOEbgmuoXZZgcRLGAnJbWwxJJVu6YwPqJeYjsxrJZx6U6R2WZUrikkISkB8AaVNjkkTWneswAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/ic_btn_delete_press@3x.png
// module id = 736
// module chunks = 0